import { format } from 'date-fns';
import { es } from 'date-fns/locale';

import { Payment } from '../../types/payment.type';
import NumberUtil, { Currency } from '../../utils/number.util';
import {
    mapPaymentStatusColor,
    mapPaymentStatusDescription,
} from '../../utils/payment-status.util';
import NarrowRightIcon from '../../icons/narrow-right/narrow-right.icon';

import styles from './payment-details-card.module.scss';
import CreditCardIcon from './credit-card.svg';

interface Props {
    payment: Payment;
    onLink: (id: number) => void;
}

const PaymentDetailsCard = (props: Props) => {
    const renderAmount = (payment: Payment): string => {
        return NumberUtil.formatCurrency(
            payment.amount * payment.exchangeRate,
            payment.currency as Currency
        );
    };

    return (
        <div className={styles.card}>
            <img src={CreditCardIcon} />
            <div className={styles.details}>
                <span className={styles.amount}>
                    {renderAmount(props.payment)}{' '}
                </span>
                <span>
                    {format(
                        new Date(props.payment.createdAt),
                        'dd MMMM, yyyy',
                        { locale: es }
                    )}
                </span>
                <span>Ref: {props.payment.referenceCode}</span>
            </div>
            <div className={styles.details} style={{ alignItems: 'flex-end' }}>
                <div
                    className={styles.status}
                    style={{
                        backgroundColor: mapPaymentStatusColor(
                            props.payment.status
                        ),
                    }}
                >
                    <div
                        className={styles.expandedColor}
                        style={{
                            backgroundColor: mapPaymentStatusColor(
                                props.payment.status
                            ),
                        }}
                    />
                    <span className={styles.tooltip}>
                        {mapPaymentStatusDescription(props.payment.status)}
                    </span>
                </div>
                <div style={{ cursor: 'pointer' }}>
                    <NarrowRightIcon
                        size={24}
                        onClick={() => props.onLink(props.payment.id)}
                    />
                </div>
            </div>
        </div>
    );
};

export default PaymentDetailsCard;
